import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const elasticacheOption: Option<CriteriaKey> = {
  name: 'Amazon ElastiCache',
  description:
    'Amazon ElastiCache is a fully managed, Redis- and Memcached-compatible service delivering real-time, cost-optimized performance for modern applications. ElastiCache scales to hundreds of millions of operations per second with microsecond response time, and offers enterprise-grade security and reliability.',
  tags: ['NoSQL', 'key-value', 'in-memory'],
  pros: [
    'In-memory caching',
    'Scalability',
    'Compatibility with popular caching engines',
    'Easy integration with AWS services',
  ],
  cons: ['Data volatility', 'Complexity of cache management'],
  documentationLink: 'https://aws.amazon.com/elasticache/',
  criteriaScores: {
    availability: { score: { value: 8 } },
    securityAndCompliance: { score: { value: 8 } },
    performanceAndScalability: { score: { value: 10 } },
    dataConsistency: { score: { value: 5 } },
    dataStructure: { score: { value: 1 } },
    costOptimization: { score: { value: 8 } },
    dataPersistence: { score: { value: 1 } },
  },
};
